import React, { useEffect, useRef, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../data/site';
import { Logo } from './Logo';
import { BookingButton } from './BookingButton';
import { trackEvent } from '../utils/analytics';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsOpen(false);
    };
    const onPointer = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    window.addEventListener('keydown', onKey);
    document.addEventListener('mousedown', onPointer);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.removeEventListener('mousedown', onPointer);
    };
  }, [isOpen]);
  const close = () => setIsOpen(false);
  return <header className="sticky top-0 z-50 bg-paper/95 backdrop-blur-sm border-b border-rule" data-id="element-82" data-mp="9opxjewbcr38">
      <div className="max-w-content mx-auto px-5 sm:px-6 lg:px-10" data-id="element-83" data-mp="enkiamducppz">
        <div className="h-[4.5rem] flex items-center justify-between gap-4 sm:gap-6" data-id="element-84" data-mp="elpvt3mx8pjs">
          <Logo onClick={close} data-id="element-85" data-mp="jn6rmkqjtlti" />

          <div className="flex items-center gap-3 sm:gap-4 lg:gap-8" data-id="element-86" data-mp="olqf4pksj5nz">
            <nav aria-label="Primary" className="hidden lg:flex items-center gap-8" data-id="element-87" data-mp="okyu28otkqby">
              {navItems.map(item => <a key={item.id} href={`#${item.id}`} onClick={() => trackEvent('nav_click', {
              link: item.id,
              menu: 'header'
            })} className="text-[0.9375rem] text-ink-soft hover:text-forest whitespace-nowrap transition-colors duration-200" data-id="element-88" data-mp="3s2gqljz56ax2">
                  {item.label}
                </a>)}
            </nav>

            <BookingButton location="header" size="sm" className="hidden sm:inline-flex whitespace-nowrap" data-id="element-89" data-mp="39bpi0kmzaojq" />

            <div ref={menuRef} className="relative lg:hidden" data-id="element-90" data-mp="31arrl211lplm">
              <button type="button" onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen} aria-controls="mobile-nav" aria-label={isOpen ? 'Close menu' : 'Open menu'} className="-mr-2 p-2 text-ink hover:text-forest transition-colors duration-200" data-id="element-91" data-mp="318x3xfydzjdu">
                {isOpen ? <XIcon size={22} data-id="element-92" data-mp="2icnrex34v0vy" /> : <MenuIcon size={22} data-id="element-93" data-mp="2ie8k0h5w09r6" />}
              </button>

              {isOpen && <nav id="mobile-nav" aria-label="Primary mobile" className="absolute right-0 top-full mt-2 w-max min-w-[11rem] bg-paper-raised border border-rule rounded-lg shadow-[0_8px_24px_rgba(31,36,33,0.08)] py-2" data-id="element-94" data-mp="2dfozml6xz60x">
                  {navItems.map(item => <a key={item.id} href={`#${item.id}`} onClick={() => {
                trackEvent('nav_click', {
                  link: item.id,
                  menu: 'mobile_menu'
                });
                close();
              }} className="block px-5 py-2.5 text-base text-ink-soft hover:text-forest hover:bg-sage transition-colors duration-150" data-id="element-95" data-mp="2lsyhuvp1jrl">
                      {item.label}
                    </a>)}
                </nav>}
            </div>
          </div>
        </div>
      </div>
    </header>;
}